import { normalisePhone } from "./phoneUtils";
import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Identity phone key for search / uniqueness.
 * Singapore numbers reuse the existing 8-digit authority.
 * Other numbers keep an E.164-style +digits form and are never forced into SG format.
 */
export function normalizeCustomerPhoneIdentity(raw: string | null | undefined): string | null {
  const text = String(raw ?? "").trim();
  if (!text) return null;
  const sg = normalisePhone(text);
  if (sg) return sg;
  const digits = text.replace(/\D/g, "");
  if (digits.length < 8 || digits.length > 15) return null;
  if (text.startsWith("+") || digits.length > 8) return `+${digits}`;
  return digits;
}

/**
 * Canonical phone accepted for Clarity One WhatsApp OTP.
 * Singapore inputs retain the established 8-digit mobile key. International
 * numbers must include a country code and are stored as +digits.
 */
export function normalizeClarityOneOtpPhone(raw: string | null | undefined): string | null {
  const text = String(raw ?? "").trim();
  if (!text) return null;
  const sgMobile = normalisePhone(text);
  if (sgMobile) return sgMobile;
  if (!text.startsWith("+")) return null;
  const parsed = parsePhoneNumberFromString(text);
  if (!parsed?.isValid() || parsed.country === "SG") return null;
  return parsed.format("E.164");
}

export function phonesIdentityMatch(
  a: string | null | undefined,
  b: string | null | undefined,
): boolean {
  const na = normalizeCustomerPhoneIdentity(a);
  const nb = normalizeCustomerPhoneIdentity(b);
  if (!na || !nb) return false;
  return na === nb;
}

export const CUSTOMER_PHONE_LABELS = [
  "Mobile",
  "Home",
  "Office",
  "Overseas",
  "Assistant",
  "Spouse",
  "Other",
] as const;

export type CustomerPhoneLabel = (typeof CUSTOMER_PHONE_LABELS)[number];
